import { SelectOption } from '../components/ui/SearchableSelect';

interface GenderBadge {
  label: string;
  className: string;
}

const GENDER_BADGES: Record<number, GenderBadge> = {
  1: { label: 'Menino', className: 'text-olivine-dark' },
  2: { label: 'Menina', className: '' },
  4: { label: 'Unissex', className: 'text-chocolate-dark' },
};

export function getGenderBadge(gender: number): GenderBadge | null {
  return GENDER_BADGES[gender] ?? null;
}

export interface BabyGenderOption {
  value: number;
  label: string;
}

export const BABY_GENDER_OPTIONS: BabyGenderOption[] = [
  { value: 1, label: 'Menino' },
  { value: 2, label: 'Menina' },
  { value: 3, label: 'Neutro' },
];

export const BABY_GENDER_SELECT_OPTIONS: SelectOption[] = BABY_GENDER_OPTIONS.map((g) => ({
  id: g.value,
  label: g.label,
}));
